export const imageExists = (path: string) => (
	new Promise((resolve) => {
		const img = new Image();

		img.onload = () => resolve(true);
		img.onerror = () => resolve(false);
		img.src = path;
	})
);
